export const LEVELUP_LEARNING = 'レベルアップ';
export const NO_IMAGE_URL =
  'https://lh3.googleusercontent.com/0HevMRzYjxmQN-of6kNcxX3FkxXQ691DI8BUocq_1ocgKoFJbeNsPAqHqcwpVCt1XnL0t3BXAWb4RamuDf3mMWs5ctksmiH3uq07QGMK-lUU=w120';
